import { LanguageTranslation } from '../types';

export const es: LanguageTranslation = {
  name: 'Español',
  export: 'Exportar',
  ok: 'OK',
  generics: {
    cancel: 'Cancelar',
    send: 'Enviar',
    editMessagePlaceholder: 'Edita tu mensaje...',
    yes: 'Si',
    no: 'No',
    noSelectionYet: ' Aún no seleccionado',
    to: ' a ',
    loading: 'Cargando datos',
    reorder: 'Reordenar',
    nothingToSee: 'No hay nada para ver aquí.',
    noTransactions: 'No hay transacciones en este rango de tiempo.',
    card: 'Tarjeta',
    buttonHome: 'Ir al tablero',
    go: 'Ir',
  },
  exportOrder: {
    whatEmailExport: '¿A cuál correo quieres que le exportemos los datos?',
    dataSent: 'Datos enviados',
    exportError: 'Ocurrió al exportar los datos',
    format: 'Formato',
    formatCsv: 'CSV',
    formatQbo: 'QBO',
    csvHelper: 'Exportación estándar con todas las columnas',
    qboHelper: 'Compatible con QuickBooks Online',
  },
  header: {
    signOut: 'Cerrar sesión',
  },
  pagedConnectionTable: {
    previous: 'Anterior',
    next: 'Siguiente',
    pagination: 'Viendo %{curr}-%{all} de %{total} resultados',
  },
  timeSpan: {
    today: 'Hoy',
    thisWeek: 'Esta semana',
    aWeekAgo: 'hace una semana',
    yesterday: 'Ayer',
    theSameDay: 'el mismo día de la semana pasada',
    last7Days: 'Últimos 7 días',
    prevDays: 'los 7 días anteriores',
    lastWeek: 'Última semana',
    samePeriod: 'el mismo período de la semana anterior',
    last30Days: 'Últimos 30 días',
    previous30Days: 'los 30 días anteriores',
    thisMonth: 'Este mes',
    thisYear: 'Este año',
    samePeriodLastMonth: 'el mismo período del mes anterior',
    samePeriodLastYear: 'el mismo período del año anterior',
    lastMonth: 'Último mes',
    thisQuarter: 'Este trimestre',
    lastQuarter: 'Último trimestre',
    tomorrow: 'Mañana',
    next7Days: 'Próximos 7 días',
    nextWeek: 'Próxima semana',
    next30Days: 'Próximos 30 días',
    nextMonth: 'Próximo mes',
    nextQuarter: 'Próximo trimestre',
    custom: 'Personalizado',
    weekCountForward: {
      one: 'Dentro de %{count} semana',
      other: 'Dentro de %{count} semanas',
    },
    weekCountBackward: {
      one: '%{count} semana atrás',
      other: 'hace %{count} semanas',
    },
  },
  dateRange: '%{start} a %{end}',
  general: {
    filters: {
      search: 'Buscar por nombre, correo, o teléfono',
    },
    restaurantList: {
      only: 'Solo',
      selectAll: 'Seleccionar todos',
      done: 'Listo',
      locations: '%{selectionLength} Ubicaciones',
      selectLocation: 'Seleccionar ubicación',
    },
    table: {
      name: 'Nombre',
      email: 'Correo',
      phone: 'Teléfono',
      totalSpent: 'Total gastado',
      orders: 'Pedidos',
      marketingEmails: 'Correos de marketing',
      optedIn: 'Inscripto',
      viewMore: 'Ver más',
    },
  },
  mainMenu: {
    chatHistory: 'Historial de chat',
    newAiChat: 'Nuevo chat de IA',
    preferences: 'Preferencias',
    customers: 'Clientes',
    employees: 'Empleados',
    invoices: 'Facturas',
    aiAssistant: 'Asistente de IA',
    payouts: 'Pagos',
    salesSummary: 'Resumen de ventas',
    scheduledOrders: 'Pedidos programados',
    scheduledOrdersDescription: 'Pedidos programados para hoy o después',
    shifts: 'Turnos',
    giftCards: 'Tarjetas de regalo',
    settings: 'Configuración de Restaurante',
    management: 'Administración',
    allShifts: 'Todos los turnos',
    allEmployees: 'Todos los empleados',
    allInvoices: 'Todas las facturas',
    allPayouts: 'Todos los pagos',
    deleteChat: 'Eliminar',
    renameChat: 'Renombrar',
    loyalty: 'Lealtad',
  },
  scheduledOrders: {
    scheduledFor: 'Programados para %{range}',
    onDate: 'el %{date}',
    header: 'Programado para %{fulfillment} %{date} a las %{time}',
    accept: 'Aceptar',
    reject: 'Rechazar',
    acceptPending: 'Aceptando el pedido programado...',
    rejectPending: 'Rechazando el pedido programado...',
    acceptSuccess: 'Pedido programado aceptado.',
    rejectSuccess: 'Pedido programado rechazado.',
    acceptError: 'Hubo un error al aceptar el pedido programado.',
    rejectError: 'Hubo un error al rechazar el pedido programado.',
    accepted: 'Aceptaste este pedido.',
    rejected: 'Este pedido fue rechazado.',
  },
  customers: {
    customers: 'Clientes',
    marketingOptIn: 'Suscripción a Marketing:',
    customerNotFound: 'Cliente no encontrado',
    ohoh: 'Oh oh',
    overview: 'Resumen',
    daily: 'Diario',
    almostDaily: 'Casi Diaria',
    weekly: 'Semanal',
    monthly: 'Mensual',
    seldomly: 'Raramente',
    firstOrder: 'Primer Pedido',
    lastOrder: 'Último Pedido',
    frequency: 'Frecuencia',
    averageSpent: 'Gasto Promedio',
    orders: 'Pedidos',
    averageTip: 'Propina Promedio',
    totalSpent: 'Total Gastado',
    itemName: 'Nombre del artículo',
    quantity: 'Cantidad Vendida',
    qty: 'Cant.',
    totalSales: 'Total de Ventas',
    topItems: 'Ítems más Vendidos',
    loyalty: {
      heading: 'Lealtad',
      emptyTitle: 'No participa en ningún programa de lealtad',
      emptyDescription: 'Este cliente aún no se ha unido a un programa de lealtad.',
      currentPoints: 'Puntos Actuales',
      currentPunches: 'Sellos Actuales',
      availableRewards: 'Recompensas Disponibles',
      lifetimePoints: 'Puntos de por Vida',
      totalRedemptions: 'Canjes Totales',
      programDollar: 'Puntos por dólar',
      programItem: 'Tarjeta de sellos virtual',
      edit: 'Ajustar',
      adjustTitle: 'Ajustar Saldo de Lealtad',
      pointsAdjustment: 'Ajuste de Puntos',
      punchesAdjustment: 'Ajuste de Sellos',
      reason: 'Motivo',
      reasonPlaceholder: '¿Por qué realizas este ajuste?',
      save: 'Guardar',
      cancel: 'Cancelar',
      adjustSuccess: 'Saldo de lealtad actualizado.',
      historyTitle: 'Historial',
      historyEmpty: 'Aún no hay actividad de lealtad.',
      colDate: 'Fecha',
      colType: 'Tipo',
      colChange: 'Cambio',
      colBalanceAfter: 'Saldo Resultante',
      colOrder: 'Pedido',
      colReward: 'Recompensa Canjeada',
      colActor: 'Operador',
      colReason: 'Motivo',
      typeEarn: 'Ganancia',
      typeRedeem: 'Canje',
      typeStarter: 'Inicio',
      typeAdjustment: 'Ajuste',
      points: 'Puntos',
      punches: 'Sellos',
      historyTruncated: 'Mostrando las 50 transacciones más recientes.',
      validationNonZero: 'Ingresa un cambio distinto de cero.',
      validationReason: 'El motivo es obligatorio.',
      validationReasonTooLong: 'El motivo debe tener 500 caracteres o menos.',
      validationWouldGoNegative: 'El saldo resultante no puede ser menor que cero.',
    },
  },
  devices: {
    devices: 'Dispositivos',
    subtitle:
      'Cada iPad emparejado con este restaurante. Nombra un dispositivo para facilitar el soporte.',
    nickname: 'Nombre',
    editNickname: 'Editar nombre',
    unnamedDevice: 'Dispositivo sin nombre',
    renameFailed: 'No pudimos renombrar este dispositivo. Intenta de nuevo.',
    perDeviceCashDrawers: {
      label: 'Un cajón por iPad',
      helper:
        'Cada iPad abre y cierra su propia caja. Al desactivar, todos los iPads comparten un cajón.',
      on: 'Sí',
      off: 'No',
      activeWarningTitle: 'Hay una caja abierta',
      activeWarning:
        'Hay una caja abierta. El cambio se aplicará cuando se abra la próxima. ¿Continuar?',
      activeWarningConfirm: 'Continuar',
      activeWarningCancel: 'Cancelar',
      saveFailed: 'No pudimos actualizar este ajuste. Intenta de nuevo.',
    },
    table: {
      title: 'Todos los dispositivos',
      nickname: 'Nombre',
      deviceName: 'Nombre del dispositivo (iOS)',
      appVersion: 'Versión de la app',
      lastSeen: 'Última conexión',
      status: 'Estado',
      online: 'En línea',
      offline: 'Desconectado',
    },
    detail: {
      deviceId: 'ID del dispositivo',
      settingsUpdatedAt: 'Última sincronización',
      editableHeading: 'Ajustes editables desde el panel',
      settingsHeading: 'Ajustes',
      cardPayments: {
        enabled: 'Usar Lector de Tarjeta',
        enabledGuidance:
          'Sólo afecta iPads que ya tienen un lector de tarjeta emparejado. iPads nuevos requieren emparejamiento físico por Bluetooth en el local.',
        canCreateSetupIntents: 'Guardar tarjetas para abrir cuentas',
        canCreateSetupIntentsGuidance:
          'Cuando está activado, al pasar una tarjeta para abrir una cuenta se guarda para poder cerrarla sin volver a pasar la tarjeta.',
      },
      cashDrawer: { enabled: 'Habilitar Caja Registradora' },
      printing: {
        printTickets: 'Imprimir Automáticamente Tickets',
        printStickers: 'Imprimir Automáticamente Etiquetas',
        printReceipts: 'Habilitar Recibos',
        printLogo: 'Logo de Avocado',
      },
      kds: { enabled: 'Habilitar KDS' },
      kiosk: {
        enabled: 'Habilitar Quiosco',
        acceptCash: 'Permitir pagos en efectivo',
        requirePackaging: 'Requerir Selección de Empaque',
        name: 'Nombre del quiosco',
      },
      sounds: {
        newOnlineOrders: 'Nuevos Pedidos en Línea',
        newTickets: 'Nuevos Tickets',
        ticketReminders: 'Recordatorios de Tickets',
        reminderFirstEnabled: 'Recordatorio 1',
        reminderFirstMinutes: 'Recordatorio 1 (min)',
        reminderSecondEnabled: 'Recordatorio 2',
        reminderSecondMinutes: 'Recordatorio 2 (min)',
        reminderThirdEnabled: 'Recordatorio 3',
        reminderThirdMinutes: 'Recordatorio 3 (min)',
      },
      giftCards: { enabled: 'Habilitar Tarjetas de Regalo' },
      storefront: { enabled: 'Habilitar Controles de la Tienda' },
      tables: { enabled: 'Habilitar Mesas' },
      tips: {
        enabled: 'Habilitar Propinas',
        tipBeforePayment: 'Propina Antes del Pago',
        tipOnPaper: 'Propina en Recibos de Papel',
        enableLargePartyTipScreen: 'Propina Adicional',
        showTipScreenEmployees: 'Mostrar empleados registrados en la pantalla de propinas',
      },
      checkout: {
        showAddCustomerScreen: 'Nombre y Teléfono del Cliente',
        enableTableMarkers: 'Marcador de Mesa',
        paymentLink: 'Enlace de Pago',
      },
      viewDetails: 'Ver ajustes',
      settingHeader: 'Ajuste',
      valueHeader: 'Valor',
      categoryHeader: 'Categoría',
      categories: {
        cardPayments: 'Pagos con Tarjeta',
        cashDrawer: 'Caja Registradora',
        checkout: 'Pagar',
        giftCards: 'Tarjetas de Regalo',
        kds: 'KDS',
        kiosk: 'Quiosco',
        printing: 'Impresora',
        sounds: 'Sonidos',
        storefront: 'Tienda Online',
        tables: 'Mesas',
        tips: 'Propinas',
        pairing: 'Emparejamiento',
        other: 'Otros',
      },
      notFoundHeading: 'Dispositivo no encontrado',
      notFoundBody:
        'Ningún dispositivo con este ID está emparejado con el restaurante seleccionado (%{restaurantName}). Si esperabas encontrarlo, cambia de restaurante desde el filtro superior.',
      errorHeading: 'Ocurrió un error',
      errorBody: 'No pudimos cargar este dispositivo. Intenta de nuevo en unos segundos.',
      saveFailed: 'No pudimos guardar los ajustes del dispositivo. Intenta de nuevo.',
      save: 'Guardar',
      saving: 'Guardando…',
      discard: 'Descartar',
    },
  },
  employees: {
    employees: 'Empleados',
    employeeTable: {
      addEmployee: 'Añadir Empleado',
      name: 'Nombre',
      email: 'Correo',
      location: 'Ubicación',
      phone: 'Teléfono',
      clockInCode: 'Código de entrada',
      tippable: 'Recibe propina',
      yes: 'Si',
      no: 'No',
    },
    errors: {
      codeTaken: 'Este código ya está en uso.',
      phoneTaken: 'Este número de teléfono ya está en uso.',
      unknownApiError: 'Hubo un error al guardar el empleado.',
      emailTaken: 'Este correo ya está en uso por otro empleado.',
    },
    employeeAdded: 'Empleado añadido.',
    employeeEdited: 'Empleado editado.',
    addEmployee: 'Añadir Empleado',
    selectALocation: 'Selecciona una Ubicación',
    firstName: 'Nombre',
    lastName: 'Apellido',
    clockInCode: 'Código de entrada (solo números)',
    tippable: 'Propinas habilitadas',
    deleteEmployee: 'Eliminar empleado',
    areYouSure: '¿Estás seguro de eliminar a este empleado?',
    editEmployee: 'Editar Empleado',
    saveError: 'Hubo un error al guardar el empleado.',
    saveSuccess: 'Empleado guardado.',
    createEmployee: 'Crear Empleado',
    invalidCode: 'Los códigos de entrada deben tener 4 dígitos.',
    deleteSuccess: 'Empleado eliminado.',
    deleteError: 'Hubo un error al eliminar el empleado.',
  },
  permissions: {
    REPORTING: 'Puede ver informes',
    POS_AUTH: 'Puede autenticar el POS / KDS',
    REACTION_RECIPIENT: 'Recibe notificación sobre reacciones negativas',
    ACCOUNT_MANAGEMENT: 'Puede gestionar cuentas bancarias',
  },
  invoices: {
    invoices: 'Facturas',
    createInvoice: 'Crear factura',
    editInvoice: 'Editar factura',
    paidInvoice: 'Factura pagada',
    invoicesTable: {
      createdDate: 'Fecha de creación',
      customerEventName: 'Nombre del evento/cliente',
      paymentStatus: 'Estado',
      total: 'Total',
      eventDate: 'Fecha del evento',
      stage: {
        depositDue: 'Depósito pendiente',
        balanceDue: 'Saldo pendiente',
        overdue: 'Atrasado',
      },
    },
  },
  forms: {
    fieldRequired: 'Este campo es obligatorio.',
    save: 'Guardar',
    emailInvalid: 'Correo electrónico inválido.',
  },
  invoice: {
    invoice: 'Factura',
    invoiceSaved: 'Factura guardada',
    invoiceDeleted: 'Factura eliminada',
    deleteInvoice: 'Eliminar',
    duplicateInvoice: 'Duplicar',
    yourBusinessDetails: 'Los datos de tu negocio',
    shownOnCustomerInvoice: 'Aparecen en la factura de tu cliente',
    missingBusinessDetails: 'Faltan algunos datos de tu negocio.',
    goToSettings: 'Agrégalos en configuración',
    errorCreating: 'Hubo un error al crear la factura.',
    invoiceErrorFetching: 'Hubo un error al obtener la factura.',
    recordAPaymentFor: 'Registra un pago para',
    errorSaving: 'Hubo un error al guardar la factura.',
    errorDeleting: 'Hubo un error al eliminar la factura.',
    selectARestaurant: 'Selecciona un restaurante',
    customerOrEventName: 'Nombre del Cliente o Evento',
    avocadoParty: 'Party de Avocado para Instamenu',
    customerPhoneNumber: 'Número de Teléfono del Cliente',
    customerEmail: 'Correo Electrónico del Cliente',
    phoneOrEmailRequired: 'Ingresa un número de teléfono o un correo electrónico.',
    notValidPhoneNumber: 'Ese no es un número de teléfono válido.',
    notValidEmail: 'Ese no es un correo electrónico válido.',
    item: 'Ítem',
    unit: 'Unidad',
    price: 'Precio',
    quantity: 'Cantidad',
    tax: 'Impuesto',
    included: 'Incluido',
    amount: 'Monto',
    addAnItem: 'Agregar un ítem',
    itemName: 'Nombre del ítem',
    taxRefund: 'Reembolso de impuestos',
    hide: 'Ocultar',
    options: 'Opciones',
    customerExempt: 'Este cliente está exento de impuestos',
    customerExemptReason: 'Motivo de exención de impuestos',
    customerEIN: 'Número de Identificación del Empleador (EIN) del Cliente',
    payments: 'Pagos',
    cash: 'Efectivo',
    achBankTransfer: 'Transferencia Bancaria ACH',
    noPayments: 'Aún sin pagos',
    balanceDue: 'Saldo Pendiente',
    recordACashPayment: 'Registrar un pago en efectivo',
    sendPayableInvoice:
      'Para enviar la factura a tu cliente, envíales este enlace por mensaje de texto o correo electrónico:',
    urlCopied: 'URL copiado al portapapeles.',
    copy: 'Copiar',
    errorCreatingPayment: 'Hubo un error al crear el pago.',
    outstandingAmount: ' El monto total pendiente es de %{amount} %{changeThisNumber}.',
    changeThisNumber: '. Cambia este número para registrar un pago parcial.',
    payersName: 'Nombre del pagador',
    firstName: 'Nombre',
    lastName: 'Apellido',
    fullNameRequired: 'Se requiere el nombre completo del pagador.',
    payersEmail: 'Dirección de correo electrónico del pagador',
    payersEmailRequired: 'Se requiere el correo electrónico del pagador.',
    record: 'Registrar %{payment} de %{amount} ',
    payment: ' Pago',
    processingFee: 'Tarifa de Plataforma',
    selectPaymentMethod: 'Selecciona un método de pago',
    paymentMethod: 'Método de Pago',
    acceptTips: 'Aceptar propinas',
    requireDeposit: 'Cobrar un depósito',
    depositAmount: 'Depósito',
    depositDueNow: 'Depósito a pagar ahora',
    depositInvalid: 'Ingresa un depósito entre $0.50 y el total de la factura.',
    eventDate: 'Fecha del evento',
    eventDateRequired: 'Agrega la fecha del evento para que el cliente sepa cuándo vence el saldo.',
  },
  order: {
    servers: { zero: 'Meseros', one: 'Mesero', other: 'Meseros' },
    refund: {
      orderError: 'No pudimos encontrar una orden con el ID %{id} ',
      ohoh: 'Oh-oh',
      items: 'Items',
      amount: 'Monto',
      selectAll: 'Seleccionar Todo',
      tip: 'Tip',
      processingFee: 'Tarifa de Plataforma',
      canRefundUpTo: 'Puedes reembolsar hasta: %{total}',
      refundButton: 'Reembolso %{amount}',
      refundAndCancelButton: 'Reembolsar y cancelar %{amount}',
      enterAmount: 'Ingresa el monto',
      notSoFast: ' ¡No tan rápido!',
      weCanHelp: ' Podemos ayudar',
      notPaid: 'Este pedido aún no ha sido pagado.',
      alreadyIssued:
        'Ya se ha emitido un reembolso para este pedido. Para emitir reembolsos adicionales, por favor contacta a',
      supportMail: 'support@instamenu.cc',
      forAssistance: 'para asistencia.',
      notFromDashboardPreviousDate:
        'Los reembolsos de fechas anteriores no se pueden realizar desde el panel. Para realizar el reembolso de este pedido, por favor contacta a',
      notFromDashboard:
        'Los pedidos en efectivo no pueden ser reembolsados desde el panel. Para realizar el reembolso de este pedido, por favor contacta a',
      multipleForms:
        'Los pedidos con múltiples formas de pago no pueden ser reembolsados desde el panel. Para realizar el reembolso de este pedido, por favor contacta a',
      orderHash: 'Pedido #',
      cannotBeIssued:
        'No se puede emitir un reembolso para este pedido desde el panel. Para realizar el reembolso de este pedido, por favor, contacta.',
    },
    order: 'Order',
    customerFeedBack: 'Comentarios del cliente',
    summary: 'Resumen',
    largeParty: ' - Grupo grande',
    clockedIn: 'Hora de entrada: %{time} ',
    receipt: 'Recibo',
    issueRefund: 'Gestionar Reembolso',
    cancelOrder: 'Cancelar Orden',
    cancelConfirm:
      'Seguro que quieres cancelar esta orden? Los puntos de lealtad seran restaurados.',
    duration: '%{duration} min ',
    unpaid: 'No pagado',
    tel: 'tel: ',
    phoneCode: 'Código telefónico',
    mailto: 'correo para: ',
    cashReceived: 'Efectivo Recibido',
    cashRounding: 'Redondeo de efectivo',
    cashRoundingRefunded: 'Redondeo de efectivo reembolsado',
    deliveryFee: 'Tarifa de Entrega',
    loyaltyActivity: 'Actividad de lealtad',
    loyaltyAdjustment: 'Ajuste',
    loyaltyEarn: 'Acumulado',
    loyaltyRedeem: 'Canjeado',
    loyaltyStarter: 'Bono inicial',
    pointsEarned: { zero: 'puntos', one: 'punto', other: 'puntos' },
    punchesEarned: { zero: 'sellos', one: 'sello', other: 'sellos' },
  },
  salesSummary: {
    salesSummary: 'Resumen de ventas',
    overview: {
      payout: 'Pago',
      orderTotalCollected: 'Total de Pedidos Recaudado',
      usingCash: 'Usando Efectivo',
      usingCashDescription:
        'Esto es todo lo recaudado del cliente usando efectivo, incluidos los ajustes de redondeo, las ventas de productos, los impuestos y las ventas de tarjetas de regalo. No incluye propinas en efectivo porque no se registran en el sistema. Este monto no se pagará porque ya tienes el efectivo en mano.',
      usingThirdParty: 'Usando Terceros',
      usingThirdPartyDescription:
        'Totales netos de pedidos de servicios de terceros conectados durante este período.',
      cashRounding: 'Redondeo de efectivo',
      cashRoundingDescription:
        'El monto neto con signo agregado o eliminado de las transacciones en efectivo del POS cuando el monto cobrado se redondeó a los $0.05 más cercanos. Ya está incluido en Total Recaudado y Usando Efectivo. Es un ajuste del pago, no una venta, recargo ni descuento.',
      usingGiftCards: 'Usando Tarjetas de Regalo',
      usingGiftCardsDescription:
        'Esto incluye todos los fondos recibidos de los clientes mediante tarjetas de regalo. Incluye ventas de productos, impuestos y propinas. Ya recibiste los fondos de las tarjetas de regalo, al momento de la venta de la misma.',
      salesTaxWithheld: 'Impuesto de Venta Retenido',
      salesTaxWithheldDescription:
        'Si eliges que Avocado retenga el impuesto de ventas, "Impuesto de Venta Retenido" representará la cantidad retenida. Si no eliges que retengamos tus impuestos, la cantidad será cero.',
      totalPayout: 'Pago Total',
      totalPayoutDescription:
        'La cantidad total que debes esperar recibir mediante ACH u otros medios.',
      sales: 'Ventas',
      grossSalesDescription:
        'Ventas sin descuentos ni reembolsos aplicados. Esto incluye ventas con tarjetas de crédito, efectivo y tarjetas de regalo (ventas donde el cliente usa una tarjeta de regalo para pagar, pero no cuando vendes una tarjeta de regalo). Las Ventas Brutas no incluyen impuestos de venta o propina. Las Ventas Brutas incluyen recargos.',
      grossSalesCalc:
        'Ventas Brutas = Ventas con Tarjetas de Crédito/Débito + Ventas en Efectivo + Ventas con Tarjetas de Regalo',
      grossSales: 'Ventas Brutas',
      refunds: 'Reembolsos',
      refundsDescription:
        'Todos los reembolsos con tarjetas de débito/crédito y en efectivo. Las compras realizadas con tarjetas de regalo no pueden ser reembolsadas.',
      discounts: 'Descuentos',
      discountsDescription: 'Esta es la suma de todos los descuentos de artículos y pedidos.',
      loyalty: 'Lealtad',
      loyaltyDescription:
        'Valor de artículos canjeados a través del programa de lealtad. Este monto está incluido en Ventas Brutas pero se deduce antes de Ventas Netas.',
      netSales: 'Ventas Netas',
      netSalesDescription:
        'Ventas Netas son Ventas Brutas menos Reembolsos, Descuentos y Lealtad. Las Ventas Netas no incluyen ventas de tarjetas de regalo.',
      netSalesCalc:
        'Ventas Netas = Ventas con Tarjetas de Crédito + Ventas en Efectivo + Ventas con Tarjetas de Regalo - Descuentos - Reembolsos - Lealtad',
      salesTax: 'Impuesto de Venta',
      salesTaxDescription:
        'El impuesto de ventas para todas las ventas con tarjetas de crédito/débito, en efectivo y tarjetas de regalo (ventas usando tarjetas de regalo, no ventas de tarjetas de regalo. Cuando se usa una tarjeta de regalo, se aplica el impuesto de ventas, pero cuando se vende una tarjeta de regalo, no se aplica). El Impuesto de Venta se calcula por transacción.',
      cardTips: 'Propinas con Tarjeta',
      cardTipsDescription:
        'Las propinas totales de tarjetas de débito/crédito y tarjetas de regalo, pero no en efectivo ya que las propinas en efectivo no se registran a través del sistema.',
      giftCardsSold: 'Tarjetas de Regalo Vendidas',
      invoiceNetTotal: 'Facturas Cobradas',
      invoiceNetTotalDescription:
        'Facturas Cobradas es el dinero que recaudaste de facturas durante este período. Una factura se cuenta cuando se paga, no cuando se envía, por lo que las facturas pendientes no se incluyen. Las facturas se cobran por separado de los pedidos, así que este monto no forma parte de las Ventas Brutas, las Ventas Netas ni el Total de Ventas. Sí está incluido en el Total Recaudado y en tu Pago Total.',
      totalCollected: 'Total Recaudado',
      totalCollectedDescription:
        'El Total Recaudado es la suma de tu Total de Ventas, tus Facturas Cobradas, tus Tarjetas de Regalo Vendidas y cualquier ajuste de Redondeo de efectivo.',
      salesTotal: 'Total de Ventas',
      salesTotalDescription:
        'El Total de Ventas es la suma de las ventas netas, impuestos y propinas. No incluye ventas de facturas, la venta de tarjetas de regalo ni la tarifa de plataforma de Avocado que se cobra directamente al cliente.',
      performance: 'Rendimiento',
      transactions: 'Transacciones',
      transactionsDescription:
        'El número total de transacciones de productos y tarjetas de regalo.',
      avgSale: 'Venta Promedio',
      avgSaleDescription:
        'El precio promedio de venta incluyendo descuentos y reembolsos, pero no incluyendo impuestos ni propina.',
      avgSaleCalc: 'Venta Promedio = Ventas Netas / Transacciones',
      avgSaleCalcTwo:
        'Venta Promedio = (Ventas con Tarjeta de Crédito + Ventas en Efectivo + Ventas con Tarjetas de Regalo - Descuentos - Reembolsos) / Transacciones',
      avgCardTip: 'Propina Promedio con Tarjeta',
      avgCardTipDescription:
        'La propina promedio para pedidos con tarjeta de crédito. No incluimos pedidos en efectivo ya que el sistema no conoce las propinas en efectivo. Tampoco incluimos los pedidos con tarjetas de regalo para este cálculo.',
      instamenu: 'Tarifas pagadas por los clientes',
      processingFees: 'Tarifas de Plataforma',
      processingFeesDescription:
        'Las Tarifas de Plataforma se cobran a los clientes y se calculan por transacción.',
      deliveryFees: 'Tarifas de Entrega',
      deliveryFeesDescription:
        'Las Tarifas de Entrega son tarifas cobradas directamente a los clientes por la entrega de sus pedidos.',
      merchantFees: 'Tarifas del Comerciante',
      fromMerchant: '(De Ti)',
      merchantFeesDescription:
        'Las Tarifas del Comerciante son la comisión que se te cobra. Las Tarifas del Comerciante se calculan por transacción.',
      items: 'Ítems:',
      surcharges: 'Recargos:',
      overview: 'Resumen',
      upTo: ' hasta %{time}',
    },
    customDateRange: {
      to: ' a %{date}',
      selectDateRange: 'Seleccionar rango de fechas',
      done: 'Hecho',
    },
    customTimeRange: {
      to: 'a',
      allDay: 'Todo el día',
      start: 'Principio',
      end: 'Fin',
      custom: 'Personalizado',
      done: 'Hecho',
    },
    dailySales: {
      dailySales: 'Ventas Diarias',
      comparedTo: ' comparado a ',
      to: ' a %{date}',
      to2: '%{dateOne} to %{dateTwo}',
      netSales: 'Ventas Netas',
      tips: 'Propinas',
    },
    topItems: {
      discount: 'Descuentos',
      itemGroup: 'Categoría',
      itemName: 'Nombre del ítem',
      qty: 'Cant.',
      quantitySold: 'Cantidad vendida',
      sales: 'Ventas',
      topItems: 'Ítems Más Vendidos',
    },
    topAddons: {
      topAddons: 'Extras Más Vendidos ',
      quantitySold: 'Cantidad vendida',
      qty: 'Cant.',
      itemName: 'Nombre del ítem',
      sales: 'Ventas',
    },
    orders: {
      orderId: 'ID de Pedido',
      type: 'Tipo',
      refundUpper: 'REEMBOLSO',
      source: 'Fuente',
      location: 'Ubicación',
      subtotal: 'Subtotal',
      netSales: 'Ventas Netas',
      tax: 'Impuesto',
      taxExemptWithNote: 'Impuesto Excluido (%{note})',
      taxExempt: 'Impuesto Excluido',
      includedTax: 'Impuesto Incluido',
      tip: 'Propina',
      deliveryTip: 'Propina del Repartidor',
      processingFee: 'Tarifa de Plataforma',
      total: 'Total',
      discounts: 'Descuentos',
      giftCardInitialValue: 'Valor Inicial de Tarjeta de Regalo',
      giftCardUsed: 'Tarjeta de Regalo Utilizada',
      giftCardCode: 'Código de Tarjeta de Regalo',
      transferAmount: 'Monto de Transferencia',
      customer: 'Cliente',
      customers: 'Clientes',
      note: 'Nota',
      bonus: 'Bono',
      refund: 'Reembolso',
      discount: 'Descuento',
      purchasedGiftCard: 'Tarjeta de Regalo Comprada %{code}',
      usedGiftCard: 'Tarjeta de Regalo Utilizada',
      rewards: 'Recompensas',
      rewardRedeemed: 'Recompensa canjeada',
      paidAt: 'Pagado el',
      placedAt: 'Realizado el',
      orders: 'Pedidos',
      collected: 'Recaudado %{amount}',
      included: 'Incluido',
      status: 'Estado',
      scheduledAt: 'Programado para',
      deliveryAddress: 'Dirección de entrega',
      delivery: 'Delivery',
      trackDelivery: 'Seguir entrega',
      dropoffEta: 'Hora estimada de entrega',
      driver: 'Repartidor',
    },
  },
  shifts: {
    shifts: 'Turnos',
    addShift: 'Crear Turno',
    totalByEmpAndLocation: 'Total por empleado y ubicación',
    employee: 'Empleado',
    location: 'Ubicación',
    totalDuration: 'Duración Total',
    totalTips: 'Propinas Totales',
    allShifts: 'Todos los Turnos',
    start: 'Inicio',
    end: 'Fin',
    duration: 'Duración',
    tips: 'Propinas',
    active: 'Activo',
  },
  createShift: {
    selectAnEmployee: 'Selecciona un empleado.',
    shiftsCanStart: '¡Los turnos pueden comenzar después de que terminen! 🤦‍♀️',
    shiftAdded: 'Turno añadido.',
    somethingWentWrong: 'Algo salió mal.',
    createShift: 'Crear Turno',
    noEmployees: 'Este restaurante no tiene empleados.',
    addEmployee: 'Agregar empleado',
    start: 'Inicio',
    end: 'Fin',
    selectADate: 'Sel. una fecha',
    delete: 'Eliminar',
    update: 'Actualizar',
    noId: 'No pudimos encontrar un turno con el id ',
    shiftUpdated: 'Turno actualizado.',
    shiftDeleted: 'Turno eliminado.',
    shiftAt: ' en',
  },
  payouts: {
    payouts: 'Pagos',
    createPayout: 'Crear pago',
    createPayoutDescription: 'Elige cómo quieres enviar tu saldo disponible.',
    selectRestaurant: 'Selecciona un restaurante',
    payoutMethod: 'Método de pago',
    standardPayout: 'Pago estándar',
    standardPayoutDescription: 'Gratis y normalmente llega en 1–3 días hábiles.',
    instantPayout: 'Pago instantáneo',
    currentlyUnavailable: 'Actualmente no disponible',
    instantPayoutDescription: 'Normalmente llega en 30 minutos. Se aplica una comisión.',
    availableAmount: 'Monto disponible',
    estimatedFee: 'Comisión estimada',
    estimatedDeposit: 'Depósito estimado',
    previewUnavailable: 'El pago instantáneo no está disponible para este restaurante ahora.',
    previewNoBalance: 'Todavía no hay saldo liquidado disponible para un pago instantáneo.',
    previewDestinationMissing:
      'Agrega una tarjeta de débito elegible a tu cuenta de Stripe para recibir pagos instantáneos.',
    previewDailyLimit: 'Este restaurante alcanzó su límite de pagos instantáneos por hoy.',
    previewPaused: 'Los pagos están pausados temporalmente. Inténtalo de nuevo más tarde.',
    previewAccountMissing: 'Termina de configurar tu cuenta de Stripe antes de crear un pago.',
    previewFailed: 'No pudimos cargar el monto del pago instantáneo. Inténtalo de nuevo.',
    noManagedRestaurants:
      'Necesitas permiso de administración de cuenta para crear un pago de un restaurante.',
    reviewPayout: 'Revisar pago',
    confirmPayout: 'Confirmar pago',
    cancel: 'Cancelar',
    standardConfirmation:
      'Esto enviará el saldo disponible como un pago estándar gratis. Normalmente llega en 1–3 días hábiles.',
    instantConfirmation:
      'Esto enviará un pago instantáneo. Stripe confirmará la comisión final de la aplicación.',
    payoutCreated: 'Pago creado.',
    payoutFailed: 'No pudimos crear el pago. Inténtalo de nuevo.',
    ordersFrom: 'Pedidos desde',
    location: 'Ubicación',
    amount: 'Monto',
    status: 'Estado',
    sentAt: 'Enviado el',
    payoutHours: 'Enviaremos tu próximo pago para ',
    locations: 'ubicaciones',
    at: ' a las ',
    and: ' y para ',
    for: ' para ',
    estimatedArrival: 'Los pagos generalmente tardan de 1 a 3 días hábiles en llegar a tu banco.',
  },
  aiAssistant: {
    newChat: 'Nuevo chat',
    notepad: 'Bloc de notas',
    placeholder: 'Envía un mensaje a Avocado AI',
    savedPromptHint: 'Consejo: Guarda los prompts que uses seguido para acceso rápido',
    savedPromptPlaceholder: 'Escribe un prompt...',
    save: 'Guardar',
    addSavedPrompt: 'Agregar Prompt Guardado',
    loadingSavedPrompts: 'Cargando prompts guardados...',
    delete: 'Eliminar',
    removeSavedPrompt: 'Eliminar prompt guardado',
    whatAreSavedPrompts: '¿Qué son los prompts guardados?',
    reasoning: 'Razonamiento',
    menuEditor: 'Editor de menú',
    menu: 'Menú',
    restaurant: 'Restaurante',
    heroImage: 'Imagen principal',
    kioskImage: 'Imagen de kiosco',
    logo: 'Logo',
    brandColor: 'Color de marca',
    notepadPlaceholder: 'Tanto la IA como tú pueden escribir aquí...',
    copy: 'Copiar',
    copied: 'Copiado',
    copyFailed: 'No se pudo copiar',
    exportPdf: 'Exportar PDF',
    exportingPdf: 'Exportando…',
    notepadFilename: 'bloc-de-notas.pdf',
    inStock: 'en stock',
    noLimit: 'Sin límite',
    outOfStock: 'Agotado',
    hiddenOnline: 'Oculto en línea',
    variant: 'Variante',
    hidden: 'Oculto',
    addDescription: 'Agregar una descripción…',
    addCategory: 'Agregar categoría',
    addItem: 'Agregar artículo',
    addModifierGroup: 'Agregar grupo de modificadores',
    addModifier: 'Agregar modificador',
    newCategory: 'Nueva Categoría',
    newItem: 'Nuevo Artículo',
    newModifierGroup: 'Nuevo Grupo',
    newModifier: 'Nuevo Modificador',
    count: 'Cantidad',
    min: 'Mín',
    max: 'Máx',
    remove: 'Eliminar',
    modified: 'Modificado',
    dropImage: 'Soltar imagen',
    addImage: 'Agregar imagen',
    welcomeMessage:
      '¡Hola%{firstName}! Soy una IA que ayuda en la administración de tu restaurante. Puedes hablar conmigo como lo harías con ChatGPT, pero yo ya conozco de tu negocio e incluso puedo *hacer cosas* como actualizar tu menú.',
    imageEdited: 'Aquí está la imagen editada',
    menuSaveFailed: 'No se pudieron guardar los cambios del menú. Inténtalo de nuevo.',
    menuSaveFailedWithReason: 'No se pudieron guardar los cambios del menú: %{reason}',
    menuReloadedAfterNotFound:
      'Algunos cambios no se guardaron porque esos elementos del menú ya no están en el servidor. Se recargó el menú y muestra lo que sí se guardó. Revísalo antes de hacer los cambios que faltan.',
    menuNameFieldRequired: 'El nombre es obligatorio',
    menuNameRequired:
      'Agrega un nombre a cada categoría, artículo, grupo y modificador nuevo antes de guardar.',
    settingsApproval: {
      title: 'Revisar cambios de configuración',
      description:
        'El asistente preparó los siguientes cambios. No se aplicarán hasta que los apruebes.',
      approve: 'Aprobar',
      discard: 'Descartar',
      applied: 'Configuración actualizada',
      failed: 'No se pudieron guardar los cambios de configuración',
      on: 'Activado',
      off: 'Desactivado',
      empty: '(vacío)',
    },
    devicesApproval: {
      title: 'Revisar cambios de dispositivos',
      description:
        'El asistente preparó cambios para uno o más dispositivos. Nada se aplica hasta que apruebes cada dispositivo abajo.',
      nickname: 'Nombre',
      approve: 'Aprobar',
      discard: 'Descartar',
      applied: 'Dispositivo actualizado',
      failed: 'No se pudo actualizar el dispositivo',
      staleAfterRetry:
        'Otro cambio se aplicó mientras este estaba pendiente. Pídele al asistente que vuelva a leer el dispositivo y lo intente otra vez.',
      on: 'Activado',
      off: 'Desactivado',
      empty: '(vacío)',
    },
    functionCalls: {
      image_generation: 'Generando una imagen',
      web_search: 'Buscando en internet',
      query_database: 'Consultando la base de datos',
      evaluate_math_expression: 'Calculando resultados',
      read_menu: 'Estudiando el menú actual',
      update_menu: 'Actualizando el menú',
      get_images: 'Revisando tus imágenes de tu menú',
      read_restaurant: 'Revisando la información de tu restaurante',
      update_restaurant: 'Actualizando los detalles de tu restaurante',
      confirm_restaurant_changes: 'Aplicando los cambios del restaurante',
      get_restaurant_images: 'Revisando las imágenes de tu restaurante',
      get_notepad: 'Obteniendo el contenido del bloc de notas',
      set_notepad: 'Actualizando el bloc de notas',
      set_assistant_context: 'Guardando el contexto del asistente',
      list_devices: 'Revisando tus dispositivos',
      read_device_settings: 'Leyendo la configuración del dispositivo',
      update_device: 'Actualizando dispositivo',
    },
    resumeReport: 'Reanudar informe',
    sqlRunStates: {
      starting: 'Iniciando',
      queued: 'En cola',
      generating: 'Preparando informe',
      executing: 'Consultando datos',
      retrying: 'Reintentando',
      succeeded: 'Completado',
      failed: 'Error',
      canceled: 'Cancelado',
      submitted: 'Completado',
    },
    functionCallStatus: {
      processing: 'Procesando',
      ready: 'Listo',
      completed: 'Completado',
      error: 'Error',
    },
    suggestions: {
      title: 'Sugerencias',
      improveWriting: 'Mejora la escritura',
      correct: 'Corrige',
      simplify: 'Simplifica el lenguaje',
      translate: 'Traducir a…',
    },
    loadingPhrases: {
      intro: {
        understanding: 'Entendiendo la tarea',
        considering: 'Considerando las posibilidades',
      },
      funny: {
        marinating: 'Marinando tablas de datos',
        restocking: 'Reabasteciendo las despensas digitales',
        simmering: 'Cocinando la configuración a fuego lento',
        tenderizing: 'Ablandando las respuestas del servidor',
        aligning: 'Alineando los márgenes del menú',
        whipping: 'Batiendo las analíticas',
        baking: 'Horneando funciones extra',
        greasing: 'Engrasando las tuberías de Internet',
        slicing: 'Cortando y picando métricas',
        proofing: 'Fermentando datos analíticos',
        glazing: 'Glaseando informes',
        plating: 'Emplatando interfaces de usuario',
        rolling: 'Estirando nuevos menús',
        searing: 'Sellando conexiones API',
        fermenting: 'Fermentando peticiones de red',
        salting: 'Salando contraseñas',
        garnishing: 'Decorando el panel de control',
        paring: 'Reduciendo redundancias',
        seasoning: 'Sazonando niveles de permisos',
        brewing: 'Preparando café para administradores',
        kneading: 'Amasando feedback de usuarios',
        washing: 'Lavando platos sucios',
        organizing: 'Organizando el estante de especias',
      },
    },
  },
  giftCards: {
    giftCards: 'Tarjetas de Regalo',
    code: 'Código',
    restaurantGroup: 'Grupo de Restaurantes',
    initialValue: 'Valor Inicial',
    balance: 'Balance',
    lastTransaction: 'Ultima Transacción',
    originalBalance: 'Saldo original',
    remainingBalance: 'Saldo restante: %{amount}',
    purchased: 'Comprado',
    for: ' por',
    by: ' por ',
    at: ' en %{restaurantName}',
    codeError: 'No pudimos encontrar una tarjeta de regalo con el código %{code}.',
    order: 'Pedido',
    restaurant: 'Restaurante',
    date: 'Fecha',
    transactionHistory: 'Historial de transacciones',
    giftCard: 'Tarjeta de Regalo',
  },
  loyalty: {
    settings: 'Configuración',
    createProgram: 'Crear programa',
    setUpProgram: 'Configurar programa de lealtad',
    updateProgram: 'Actualizar programa',
    programUpdated: 'Programa de lealtad actualizado',
    programCreated: 'Programa de lealtad creado',
    saveFailed: 'Error al guardar. Inténtalo de nuevo.',
    viewAnalytics: 'Ver analíticas',
    noProgram: 'No hay programa de lealtad configurado para este restaurante.',
    settingsEmptyTitle: 'Aún no hay programa de lealtad',
    settingsEmptyDescription:
      'Premia a tus clientes frecuentes e impulsa las visitas recurrentes. Configura un programa de lealtad para que los clientes acumulen puntos y canjeen recompensas.',
    // Config form
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    sectionProgramDetails: 'Detalles del programa',
    programNameLabel: 'Nombre del programa',
    programNamePlaceholder: 'ej. Programa de recompensas',
    programNameRequired: 'El nombre del programa es obligatorio',
    sectionEarningRules: 'Reglas de acumulación',
    mustBeAtLeast1: 'Debe ser al menos 1',
    starterPointsLabel: 'Puntos iniciales',
    noItemGroupsFound: 'No se encontraron grupos de artículos',
    allItemGroups: 'Todos',
    sectionRewards: 'Recompensas',
    rewardItemGroupsLabel: 'Grupos de artículos para recompensa',
    sectionDisplayNotifications: 'Visualización y notificaciones',
    smsProgressEnabledLabel: 'Enviar actualizaciones de progreso por SMS',
    sectionMessaging: 'Mensajes',
    welcomeMessageLabel: 'Mensaje de bienvenida',
    welcomeMessageHint:
      'Usa {displayName}, {pointsPerDollar} y {earningThreshold} — se reemplazarán con los valores de tu programa.',
    welcomeDefaultPoints:
      '¡Bienvenido a {displayName}! 🎉\nGana {pointsPerDollar} puntos por $1 — las recompensas llegan rápido.\nTu próximo pedido te acerca más 👀',
    welcomeDefaultPunch:
      '¡Bienvenido a {displayName}! 🎉\nCompra {earningThreshold}, llévate 1 gratis.\nEmpiezas a acumular ahora 👀',
    rewardEarnedMessageLabel: 'Mensaje de recompensa obtenida',
    rewardEarnedMessageHint: 'Usa {restaurant} — se reemplazará con el nombre de tu restaurante.',
    rewardEarnedDefaultPoints:
      '🎉 ¡Ganaste un artículo gratis en {restaurant}!\nConsíguelo en línea o en nuestro local. 😏',
    rewardEarnedDefaultPunch:
      '🎉 ¡Ganaste un artículo gratis en {restaurant}!\nConsíguelo en línea o en nuestro local. 😏',
    progressMessageLabel: 'Mensaje de progreso',
    progressMessageHint:
      'Usa {progress} y {remaining} — se reemplazarán con los valores reales del cliente.',
    progressDefaultPoints:
      'Tienes {progress} puntos en {restaurant}. ¡Sigue acumulando para tus artículos favoritos! 🍜',
    progressDefaultPunch:
      '{progress} de {remaining} sellos en {restaurant} — ¡{remaining} más para un artículo gratis! 🍜',
    cancelButton: 'Cancelar',
    confirmChangesTitle: 'Estos cambios afectarán a los clientes existentes',
    confirmChangesButton: 'Guardar cambios',
    confirmChangeDeactivate:
      '• Desactivar el programa — los clientes ya no podrán acumular ni canjear puntos',
    confirmChangeActivate: '• Reactivar el programa — los clientes volverán a acumular y canjear',
    confirmChangeEarningType:
      '• Cambiar el tipo de acumulación — los puntos actuales se conservan, pero empezarán de 0 en el nuevo tipo',
    confirmChangePointsPerDollar: '• Cambiar puntos por dólar — afecta la velocidad de acumulación',
    confirmChangeEarningThreshold:
      '• Cambiar sellos requeridos — afecta cuándo se gana una recompensa',
    confirmChangeEarningItems:
      '• Cambiar los artículos que acumulan puntos — afecta qué cuenta para las recompensas',
    confirmChangeRewardItems:
      '• Cambiar artículos canjeables — afecta lo que los clientes pueden canjear',
    // Earning type
    earningTypeLabel: 'Tipo de acumulación',
    earningTypeDollar: 'Puntos por dólar',
    earningTypeDollarDescription: 'Los clientes acumulan puntos según cuánto gastan',
    earningTypeItem: 'Tarjeta de sellos virtual',
    earningTypeItemDescription: 'Los clientes ganan un sello por cada artículo',
    earningTypeEnforcedBySibling:
      'Otra sucursal de este grupo ya usa este tipo de acumulación. Todas las sucursales del grupo comparten el mismo tipo para mantener los balances de los clientes consistentes.',
    // Dollar-based
    howItWorksDollarBased: 'Los clientes acumulan %{points} punto(s) por dólar gastado.',
    howItWorksDollarRedeem: 'Los puntos se canjean por artículos del menú según su precio.',
    pointsPerDollarLabel: 'Puntos por dólar',
    pointsPerDollarRequired: 'Puntos por dólar es requerido',
    effectiveDiscountRate: 'Tasa de descuento efectiva: ~%{rate}% en artículos canjeables',
    // Item-based
    howItWorksItemBased: 'Los clientes ganan 1 sello por cada artículo comprado.',
    howItWorksItemRedeem: 'Después de %{threshold} sellos, obtienen un artículo gratis.',
    earningThresholdLabel: 'Sellos para una recompensa',
    earningThresholdRequired: 'Sellos requeridos es obligatorio',
    earningItemGroupsLabel: 'Qué artículos ganan recompensas',
    rewardIncludesModifiersLabel: 'El artículo gratis incluye extras opcionales',
    rewardIncludesModifiersDescription:
      'Las opciones obligatorias (como el tamaño) siempre están incluidas en la recompensa. Activá esto para cubrir también los extras opcionales como jarabes, toppings y adicionales.',
    // Default message templates (shown when creating a new program)
    defaultWelcomeDollar:
      '¡Bienvenido a %{name}! 🎉\nGana %{pts} puntos por cada $1 — las recompensas llegan rápido.\nTu próximo pedido te acerca más 👀',
    defaultWelcomeItem:
      '¡Bienvenido a %{name}! 🎉\nCompra %{threshold}, lleva 1 gratis.\nEmpiezas a acumular ahora 👀',
    defaultRewardEarnedDollar:
      '🎉 ¡Ganaste un artículo gratis en %{restaurant}!\nConsíguelo en línea o en nuestro local. 😏',
    defaultRewardEarnedItem:
      '🎉 ¡Ganaste un artículo gratis en %{restaurant}!\nConsíguelo en línea o en nuestro local. 😏',
    defaultProgressDollar:
      '¡Tienes {progress} puntos en %{restaurant}! Sigue acercándote a tus artículos favoritos 🍜',
    defaultProgressItem:
      '{progress} de %{threshold} sellos en %{restaurant} — ¡{remaining} más para ganar un artículo gratis! 🍜',
    // Etiqueta del dashboard para artículos compensados en recibos
    loyaltyReward: 'Recompensa de lealtad',
    // Analíticas
    analytics: {
      _: 'Analíticas',
      totalEnrolled: 'Total inscritos',
      newEnrollments: 'Nuevas inscripciones',
      enrolled: 'Inscritos',
      activeMembers: 'Activos (30d)',
      rewardsRedeemed: 'Recompensas canjeadas',
      penetration: 'Tasa de inscripción',
      ofTransactions: 'de clientes',
      dailyActivity: 'Actividad diaria',
      enrollments: 'Inscripciones',
      redemptions: 'Canjes',
      pointsEarned: 'Puntos ganados',
      punchesEarned: 'Sellos ganados',
      membersVsNonMembers: 'Miembros vs no miembros',
      members: 'Miembros',
      nonMembers: 'No miembros',
      membersSpendMore: 'Los miembros gastan %{percent}% más por visita',
      memberRevenue: 'Ingresos de miembros',
      rewardCost: 'Costo de recompensas',
      roi: 'Ingreso por dólar de recompensa',
      topCustomers: 'Mejores clientes',
      visits: 'visitas',
      rewards: 'recompensas',
      overview: 'Resumen',
      avgSpendMembers: 'Gasto prom. (miembros)',
      avgSpendNonMembers: 'Gasto prom. (no miembros)',
      spendDifference: 'Diferencia de gasto',
      orders: 'Pedidos',
      avgSpend: 'Gasto prom.',
      repeatRate: 'Tasa de retorno',
      repeatRateMembers: 'Tasa de retorno (miembros)',
      repeatRateNonMembers: 'Tasa de retorno (no miembros)',
      rightAxis: 'eje derecho',
      errorTitle: 'No se pudieron cargar las analíticas',
      noProgramTitle: 'Sin programa de lealtad',
      noProgramDescription: 'Configura un programa de lealtad para ver las analíticas.',
      emptyTitle: 'Sin actividad aún',
      emptyDescription: 'Cuando los clientes se inscriban, las analíticas aparecerán aquí.',
    },
  },
  unauthorized: {
    noAccess: 'Esta cuenta no tiene acceso. Por favor contacta con',
    signOut: 'Cerrar sesión',
  },
  notFound: {
    dontExist: 'Esta página no existe. Vuelve a la ',
    homePage: 'página principal',
  },
  settings: {
    stripe: {
      defaultDisplayName: 'tu negocio',
      title: 'Cumplimiento y Banca',
      description: 'Modifica tu información de negocio y administra cuentas bancarias.',
      locations: 'ubicaciones',
      requirementsDue:
        'Necesitamos información adicional sobre %{displayName} para continuar mandar pagos. Por favor proporciona esta información lo antes posible.',
      onboardingSuccess: 'Tu cuenta para %{displayName} está activa y lista para recibir pagos.',
      noAccounts: 'No tienes acceso para administrar cuentas externas.',
      accountsLoadFailed: 'No pudimos cargar tus cuentas. Revisa tu conexión e inténtalo de nuevo.',
      accountsLoadRetry: 'Intentar de nuevo',
      edit: 'Editar',
      needsUpdate: 'Necesita actualización',
    },
    restaurantSettings: {
      restaurantSettings: 'Configuración del Restaurante',
      name: 'Nombre',
      phone: 'Teléfono',
      address: 'Dirección',
      tagline: 'Descripción',
      openingHours: 'Horario de Apertura',
      specialHours: 'Horarios Especiales',
      nameOfTheSpecialHoursEvent: 'Nombre del evento de horarios especiales',
      save: 'Guardar',
      cancel: 'Cancelar',
      taglinePlaceholder: 'Describe tu restaurante en pocas palabras',
      addressPlaceholder: 'Calle Principal 123, Ciudad, País',
      addSpecialHours: 'Agregar Horarios Especiales',
      closed: 'Cerrado',
      to: 'a',
      phoneError: 'Ingresa un número de teléfono válido',
      restaurantNameRequired: 'El nombre del restaurante es requerido',
      openingHoursError: 'Cada turno debe tener un inicio y fin',
      weekday: {
        '1': 'Lunes',
        '2': 'Martes',
        '3': 'Miércoles',
        '4': 'Jueves',
        '5': 'Viernes',
        '6': 'Sábado',
        '7': 'Domingo',
      },
      settingsUpdatedSuccessfully: '¡Configuración actualizada!',
      nameRequired: 'El nombre es requerido',
      dateRequired: 'La fecha es requerida',
      incompleteOpeningPeriods: 'Por favor, completa todos los horarios de apertura',
      dateAlreadyExists: 'Ya existe un horario especial para esta fecha',
      settingsUpdateFailed: 'Error al actualizar la configuración',
      openingHoursExceptionUpdateFailed: 'Error al actualizar el horario especial',
      salesTax: 'Impuesto de Venta',
      cashRounding: 'Redondeo de efectivo',
      cashRoundingDescription:
        'Redondea solo las transacciones en efectivo del POS a los $0.05 más cercanos. No afecta los pagos con tarjeta, tarjeta de regalo, en línea ni de facturas.',
      cashRoundingSaveFailed: 'No se pudo actualizar el redondeo de efectivo. Inténtalo de nuevo.',
      banner: 'Banner',
      bannerPlaceholder: 'Algo que te gustaría decir a tus clientes',
      specialInstructions: 'Instrucciones especiales',
      enableSpecialInstructions:
        'Permitir que los usuarios puedan agregar instrucciones especiales a los artículos en pedidos en línea',
      scheduledOrders: 'Pedidos programados',
      enableScheduledOrders: 'Habilitar pedidos programados',
      minLeadMinutes: 'Tiempo mínimo de anticipación (minutos)',
      minGrossSubtotal: 'Monto mínimo del pedido ($)',
      scheduledSlotLength: 'Duración del intervalo de pedido programado (minutos)',
      scheduledSlotLengthInvalid: 'Ingresa un múltiplo positivo de 5',
      general: 'General',
      onlineOrdering: 'Pedidos en línea',
      enableOnlineOrdering: 'Habilitar pedidos en línea',
      hours: 'Horarios',
      bankingAndCompliance: 'Cumplimiento y Banca',
      devices: 'Dispositivos',
      connectedDocuments: 'Documentos',
      noStripeAccount1: 'Por favor, contacta a ',
      noStripeAccount2: ' para terminar de configurar tu cuenta.',
      noStripeAccountNoPhone:
        'Por favor, contacta al equipo de soporte para terminar de configurar tu cuenta.',
      brandColor: 'Color de la marca',
      restaurantGroupColorUpdateFailed: 'Error al actualizar el grupo de restaurantes',
      restaurantGroupColorUpdated: 'Grupo de restaurantes actualizado',
      storefrontUrl: 'URL de la tienda',
      copy: 'Copiar',
      qrCodeAlt: 'Código QR de la tienda',
      downloadPng: 'Descargar PNG',
      downloadSvg: 'Descargar SVG',
      qrDownloadFailed: 'No pudimos generar la descarga del QR. Inténtalo de nuevo.',
      copyUrl: 'Copiar URL',
      close: 'Cerrar',
      copied: '¡Copiado!',
      coverTitle: 'Imagen de Portada',
      createWithAi: 'Crear con IA',
      failedToEnhance: 'Error al mejorar la imagen con IA. Por favor, inténtalo de nuevo.',
      failedToProcess: 'Error al procesar la imagen. Por favor, inténtalo de nuevo.',
      smartCrop: 'Recorte Inteligente',
      logo: 'Logo',
      remove: 'Eliminar',
      kioskBackground: 'Imagen de Fondo del Kiosco',
      externalReviewUrl: 'URL de reseñas externa',
      externalReviewUrlDescription:
        'Los clientes serán dirigidos a esta URL si dejan comentarios positivos en Avocado.',
      externalReviewUrlPlaceholder: 'https://g.page/r/tu-restaurante/review',
      externalReviewUrlInvalid: 'Ingresa una URL HTTPS válida',
      externalReviewClickCount: 'Clics: %{count}',
      aiAssistantMemory: 'Memoria del Asistente de IA',
      aiAssistantMemoryDescription:
        'Permite que el Asistente de IA recuerde detalles sobre tu restaurante para ofrecer mejores sugerencias y asistencia.',
      aiAssistantMemoryPlaceholder: '- Servimos almuerzo de 12-3pm y cena de 6-10pm.',
      zoom: 'Zoom',
      aspectRatios: {
        logo: 'Logo',
        portrait: 'Retrato',
        kioskBackground: 'Fondo de Kiosco',
        story: 'Historia',
        cover: 'Portada',
      },
    },
  },
  selectLanguage: {
    selectLanguage: 'Seleccionar idioma',
    english: 'Inglés',
    spanish: 'Español',
    preferred: 'Selecciona tu idioma preferido.',
    defaultLanguage: 'Idioma predeterminado',
    languageSettings: 'Idioma',
  },
  paymentTypes: {
    CARD_MANUAL_ENTRY: 'Tarjeta (Entrada Manual)',
    CARD_PRESENT: 'Tarjeta',
    CARD_STORED: 'Tarjeta (Tab)',
    CASH: 'Efectivo',
    EXTERNAL: 'Externo',
    GIFT_CARD: 'Tarjeta de Regalo',
    LEGACY_ONLINE: 'App Móvil',
    NO_PAYMENT: 'Sin Pago',
    ONLINE: 'En Línea',
    REFUND: 'Devolución', // the 'REFUND' case is not in the API, but used on the client to create an extra row in tables
    SPLIT: 'Dividido',
    US_BANK_ACCOUNT: 'Cuenta bancaria Estados Unidos',
  },
  fulfillment: {
    DELIVERY: 'entrega',
    PICKUP: 'recogida',
  },
  status: {
    submitted: 'Ingresado',
    deliveryAccepted: 'Conductor aceptó el pedido',
    pickupEnroute: 'En camino a recoger',
    atPickup: 'En recogida',
    dropoffEnroute: 'En camino a entregar',
    delivered: 'Entregado',
    deliveryProblem: 'Problema de entrega',
    returned: 'Pedido devuelto',
    deliveryCanceled: 'Entrega cancelada',
    unknown: 'Estado desconocido',
    created: 'Creado',
    placed: 'Colocado',
    accepted: 'Aceptado',
    completed: 'Completado',
    canceled: 'Cancelado',
  },
  appErrors: {
    reloadLabel: 'Recargar página',
    retryLabel: 'Intentar de nuevo',
    newAppVersionDescription:
      'Facundo, Marvin y Shayan han estado trabajando en una nueva versión de este sitio. Recarga la página para obtener la última versión.',
    newAppVersionTitle: 'Vaya',
    unexpectedErrorDescription: 'Algo se rompió inesperadamente.',
    unexpectedErrorTitle: 'Uy',
  },
  dropzone: {
    label: 'Suelta tu archivo aquí',
  },
};
